import * as React from 'react';
import * as Util from '../util';

interface State {
    title: string;
    body: any;
    footer?: any;
}

class UniModal extends React.Component<object, State> {
    showUpdate = false;
    state: State = {
        title: '',
        body: 'body'
    };
    componentDidUpdate() {
        if (this.showUpdate) {
            this.showUpdate = false;
            Util.showModal('unimodal');
        }
    }
    render() {
        const {title, body, footer} = this.state;
        return Util.modal('unimodal', title, body, footer);
    }
}

let uniModal: UniModal;

export const showModal = (title: string, body: any, footer?: any) => {
    uniModal.showUpdate = true;
    uniModal.setState({title, body, footer});
};

export const UniModalWrapper = () => (
    <div>
        <UniModal ref={u => uniModal = u as UniModal} />
    </div>
);

export const hideModal = () => Util.hideModal('unimodal');


// WEBPACK FOOTER //
// ./src/widgets/UniModal.tsx